import { createFileRoute } from '@tanstack/react-router'
import { useOrganization } from '@/pages/organizations/detail'
import { useReports } from '@/pages/organizations/detail/reports'
import ChildrenOfTypePage from '@/features/reports/components/pages/ChildrenOfTypePage'

export const Route = createFileRoute(
  '/app/organizations/$organizationId/reports/children/$childOrgTypeMachineName/',
)({
  component: RouteComponent,
})

function RouteComponent() {
  const { childOrgTypeMachineName } = Route.useParams()
  const { organization } = useOrganization()
  const { userCanViewAssessmentsChild, userCanViewActionPlanChild, userCanViewTeamChild } = useReports()

  return (
    <ChildrenOfTypePage
      organization={organization}
      childOrgTypeMachineName={childOrgTypeMachineName}
      userCanViewAssessmentsChild={userCanViewAssessmentsChild}
      userCanViewActionPlanChild={userCanViewActionPlanChild}
      userCanViewTeamChild={userCanViewTeamChild}
    />
  )
}
